import React, { useContext } from 'react';
import { array, string, func } from 'prop-types';
import ApplicationContext from 'components/ApplicationContext';
import FeaturesMobile from './components/FeaturesMobile';
import FeaturesDesktop from './components/FeaturesDesktop';

const Features = props => {
  const {
    screenWidth: { isMobile },
  } = useContext(ApplicationContext);

  if (!props.featuresConfig || props.featuresConfig.length === 0) return null;

  // NOTE: encountered something similar to this issue: https://github.com/yocontra/react-responsive/issues/162
  return isMobile ? (
    <>
      <FeaturesMobile {...props} />
      <br style={{ display: 'none' }} /> {/* Ugly workaround */}
    </>
  ) : (
    <>
      <br style={{ display: 'none' }} /> {/* Ugly workaround */}
      <FeaturesDesktop {...props} />
    </>
  );
};

Features.propTypes = {
  id: string,
  title: string.isRequired,
  description: string.isRequired,
  featuresConfig: array.isRequired,
  onScrollHalf: func,
  className: string,
  activeClassName: string,
};

Features.defaultProps = {
  id: '',
  className: '',
  activeClassName: '',
  onScrollHalf: null,
};

export default Features;
